<template>
    <div class="home-admin mb-3 mt-4">

        <h1 class="mb-4">{{ $i18n.gt('HEADING_ADMIN_DASHBOARD') }}</h1>

        <div class="row mb-4">
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_COMPANIES_PLANS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link to="/company/admin">{{
                                        $i18n.gt('LABEL_MANAGE_COMPANIES_PLANS')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_PARTICIPANTS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link to="/participant/admin">{{
                                        $i18n.gt('HEADING_MANAGE_PARTICIPANTS')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_ADMIN_FUNCTIONS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link to="/admin/admin">{{ $i18n.gt('LABEL_MANAGE_ADMINS') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/resellerAdmin/admin">{{ $i18n.gt('LABEL_MANAGE_RESELLER_ADMINS') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/companyAdmin/admin">{{ $i18n.gt('LABEL_MANAGE_COMPANY_ADMINS') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/admin/options">{{ $i18n.gt('LABEL_OPTIONS') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/userlog/browse">{{ $i18n.gt('LABEL_VIEW_LOGS') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/clientReports">{{ $i18n.gt('LABEL_CLIENT_REPORTS') }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import Vue from 'vue'

/**
 * Home page for global admins
 */
export default Vue.extend({
    name: "HomeAdmin",
})
</script>

<style lang="scss">

@media (max-width: 500px) {
    .home-admin {
        .btn {
            width: 100%;
        }
    }
}

@media (max-width: 1000px) {
    .home-admin {
        .btn {
            margin-bottom: 1em;
        }
    }
}

</style>
